import React, { useMemo } from 'react';
import { Modal, Button, Select } from '../ui';
import { useBuilderEditor } from '../../features/builder/BuilderEditorContext';

const MoveSectionModal = () => {
  const {
    showMoveSectionModal,
    closeMoveSectionModal,
    sectionToMove,
    sectionFromParentId,
    moveTargetParentSectionId,
    setMoveTargetParentSectionId,
    confirmMoveSectionToParent,
    formdata,
  } = useBuilderEditor();

  const fromParentId = sectionFromParentId ?? 0;
  const isMovingSection = fromParentId === 0;

  const sectionOptions = useMemo(() => {
    const options = [{ value: '', label: 'Select section…' }];
    if (!isMovingSection) {
      options.push({ value: '0', label: 'No Section' });
    }

    (formdata?.sections || []).forEach((section) => {
      if (section.id !== fromParentId && section.id !== sectionToMove?.id) {
        options.push({ value: String(section.id), label: section.title });
      }
    });

    return options;
  }, [formdata?.sections, fromParentId, isMovingSection, sectionToMove?.id]);

  const canMove = moveTargetParentSectionId !== ''
    && moveTargetParentSectionId !== String(fromParentId);

  return (
    <Modal
      show={showMoveSectionModal}
      onClose={closeMoveSectionModal}
      title={isMovingSection ? 'Move section' : 'Move subsection'}
      footer={
        <>
          <Button variant="secondary" onClick={closeMoveSectionModal}>Cancel</Button>
          <Button variant="primary" onClick={confirmMoveSectionToParent} disabled={!canMove}>
            Move
          </Button>
        </>
      }
    >
      <p className="builder-text-secondary builder-move-field-modal__hint">
        Move &ldquo;{sectionToMove?.title || `Untitled ${isMovingSection ? 'section' : 'subsection'}`}&rdquo; to another section
        {isMovingSection ? '' : ', or make it a top-level section'}.
      </p>
      <Select
        label="Destination section"
        value={moveTargetParentSectionId}
        onChange={(e) => setMoveTargetParentSectionId(e.target.value)}
        options={sectionOptions}
      />
    </Modal>
  );
};

export default MoveSectionModal;
